
export default {
  name: 'icon-arrow',
};
